import { useSelector } from "react-redux";

export function useGetSectorData() {
  const sectorData = useSelector((state) => state.misc.sectorData);

  return sectorData;
}
